import React from 'react';

const StepNavigation = ({ onBack, currentStep }) => {
  if (currentStep < 2) return null;
  return (
    <button type="button" onClick={onBack} className="back-btn">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 12H5M12 5l-7 7 7 7"/>
      </svg>
      Zurück
    </button>
  );
};

export default StepNavigation;